import { SummaryModel } from '../../../../common/entity/summary.model';
import { PermissionsModel } from '../../../../common/entity/permissions.model';
import { FormSummaryModel } from '../../../../form/form/api/entity/formSummary.model';
import { OnlineFormFormDefinitionSummaryModel } from '../../../definition/api/entity/onlineFormFormDefinitionSummary.model';
import { WorkflowTaskSummaryModel } from '../../../../workflow/task/api/model/common/workflowTaskSummary.model';

export class OnlineFormSummaryModel implements SummaryModel {
    permissions: PermissionsModel;
    form: FormSummaryModel;
    onlineFormDefinition: OnlineFormFormDefinitionSummaryModel;
    url: string;
    id: number;
    workflowTasks: WorkflowTaskSummaryModel[] = [];
}
